var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    { attrs: { size: "small" } },
    [
      _c(
        "el-form-item",
        [
          _c(
            "el-radio",
            {
              attrs: { label: 4 },
              model: {
                value: _vm.radioValue,
                callback: function ($$v) {
                  _vm.radioValue = $$v
                },
                expression: "radioValue",
              },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("ChannelManagement.cron.Specify")) + " "
              ),
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    clearable: "",
                    placeholder: _vm.$t(
                      "ChannelManagement.cron.MultipleChoices"
                    ),
                    multiple: "",
                  },
                  model: {
                    value: _vm.checkboxList,
                    callback: function ($$v) {
                      _vm.checkboxList = $$v
                    },
                    expression: "checkboxList",
                  },
                },
                _vm._l(24, function (item) {
                  return _c(
                    "el-option",
                    { key: item - 1, attrs: { value: item - 1 } },
                    [_vm._v(_vm._s(item - 1 + ":00 ~ " + (item - 1) + ":59"))]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }